/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * level of performance
 */
export type EvalDimRatingLevel = string | null;
